import { Eyebrow, GoldRule, Reveal } from "./Reveal";

const ATELIER_IMG =
  "https://assets.bigcartel.com/theme_images/148785084/a51a1a2b875d810e4e62cdd2d6fed892.jpg?auto=format&fit=max&w=1400";

const POINTS = [
  "Confection dans la Drôme — atelier Point par Point",
  "Broderie en Isère — société Brod'Art",
  "Polyester Burlington Oeko Tex, 110 g/m²",
  "Créations colorées ou imprimées sur demande",
];

const STATS = [
  ["100 %", "Confection française"],
  ["110 g/m²", "Grammage idéal"],
  ["15 j – 1 mois", "Délai de confection"],
];

export default function Atelier() {
  return (
    <section
      id="atelier"
      data-testid="atelier-section"
      className="border-y border-[#E2DBCB]/10 bg-[#141619]/40"
    >
      <div className="py-24 sm:py-32 px-6 sm:px-12 lg:px-20 max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
        <Reveal className="relative order-2 lg:order-1">
          <div className="absolute -inset-0 rounded-2xl border border-[#D4AF37]/20 -translate-x-4 translate-y-4" />
          <div className="relative overflow-hidden rounded-2xl aspect-[4/5] max-h-[620px] w-full">
            <img
              src={ATELIER_IMG}
              alt="Salon de coiffure partenaire équipé de pièces Tarantina"
              data-testid="atelier-image"
              loading="lazy"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0C0D0E]/70 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6">
              <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-[#C5A059]">
                Salons partenaires
              </p>
              <p className="mt-1 font-serif text-xl text-[#F7F5F0]">
                Nos pièces à l'épreuve des plus beaux salons.
              </p>
            </div>
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <Eyebrow>L'Atelier</Eyebrow>
            <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-light tracking-tight">
              Façonné à la main,{" "}
              <em className="italic text-[#D4AF37]">en France</em>.
            </h2>
            <GoldRule className="mt-8" />
            <p className="mt-8 text-base sm:text-lg text-[#B0ABA0] leading-relaxed">
              Le secret des salons les plus prisés ? Des peignoirs qui allient
              confort et élégance. Nos modèles sont confectionnés en noir à la
              base, mais nous adorons créer des pièces qui répondent à vos
              envies et matchent avec la décoration de votre salon. Chaque
              modèle est fabriqué en France, avec une exigence que l'industrie
              ne peut pas reproduire.
            </p>
          </Reveal>

          <Reveal delay={0.15}>
            <ul className="mt-8 space-y-4">
              {POINTS.map((pt) => (
                <li
                  key={pt}
                  className="flex items-start gap-4 text-sm text-[#B0ABA0]"
                >
                  <span className="mt-2 h-1.5 w-1.5 rotate-45 shrink-0 bg-[#D4AF37]" />
                  {pt}
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={0.25}>
            <div className="mt-12 grid grid-cols-3 gap-6 border-t border-[#E2DBCB]/10 pt-8">
              {STATS.map(([value, label], i) => (
                <div key={label} data-testid={`atelier-stat-${i}`}>
                  <p className="font-serif text-2xl sm:text-3xl text-[#D4AF37]">
                    {value}
                  </p>
                  <p className="mt-1 text-[10px] sm:text-xs font-mono uppercase tracking-[0.15em] text-[#75726B]">
                    {label}
                  </p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
